import { AlphaDimensionUnit } from '@snap-types/models/enums';

export function determineThreadSizeDimensionUnit(
  threadSize: string,
): AlphaDimensionUnit {
  if (threadSize.trimStart().startsWith('M')) {
    return AlphaDimensionUnit.METRIC;
  }

  return AlphaDimensionUnit.IMPERIAL;
}
